var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      attrs: {
        title: "上传文件",
        visible: _vm.dialogFormVisible,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.rewriteClearData()
        }
      }
    },
    [
      _c("div", { staticStyle: { display: "flex", "margin-bottom": "15px" } }, [
        _vm.eventStatus == 1
          ? _c(
              "div",
              [
                _c("el-date-picker", {
                  attrs: {
                    "value-format": "yyyy-MM-dd",
                    type: "daterange",
                    align: "right",
                    "range-separator": "至",
                    "start-placeholder": "开始时间",
                    "end-placeholder": "结束时间"
                  },
                  on: { change: _vm.datechange },
                  model: {
                    value: _vm.value2,
                    callback: function($$v) {
                      _vm.value2 = $$v
                    },
                    expression: "value2"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticStyle: { "margin-left": "15px" } },
          [
            _c(
              "el-select",
              {
                attrs: { clearable: "", filterable: "", placeholder: "请选择" },
                model: {
                  value: _vm.formData.designated,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "designated", $$v)
                  },
                  expression: "formData.designated"
                }
              },
              _vm._l(_vm.chooseList, function(item) {
                return _c("el-option", {
                  key: item.value,
                  attrs: { label: item.label, value: item.value }
                })
              }),
              1
            )
          ],
          1
        )
      ]),
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            model: _vm.formData,
            "label-width": "110px",
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            { staticClass: "lodingItem", attrs: { label: "上传文件：" } },
            [
              _c("uploadImagetow", {
                ref: "uploadImagetow",
                attrs: {
                  paramsData: _vm.formData,
                  fileType: ".xlsx,.xls",
                  filesname: "file",
                  Url: "event-award/export",
                  title: "请上传"
                },
                on: { change: _vm.getData }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }